"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInputPolyfill = void 0;
var react_1 = __importStar(require("react"));
var load_js_1 = __importDefault(require("@dan503/load-js"));
// Avoid bulk importing from index files to be more tree-shake friendly
var supportsTime_1 = __importDefault(require("@time-input-polyfill/utils/npm/common/supportsTime"));
var blankValues_1 = require("@time-input-polyfill/utils/npm/common/blankValues");
var polyfillClassName = 'react-time-input-polyfill-target';
/**
 * An `input[type=time]` element with a built in polyfill for browsers that don't support the time input natively.
 *
 * Only browsers that _need_ the polyfill code will download the polyfill.
 *
 * ```jsx
 * import TimeInput from '@time-input-polyfill/react'
 * // ...
 * const [value, setValue] = useState()
 * // ...
 * <TimeInput value={value} setValue={setValue} />
 * ```
 *
 * __Resources:__
 * - [Demo website](https://dan503.github.io/react-time-input-polyfill/)
 * - [GitHub repository](https://github.com/Dan503/react-time-input-polyfill)
 * - [npm package](https://www.npmjs.com/package/@time-input-polyfill/react)
 */
var TimeInputPolyfill = function (_a) {
    var _b = _a.value, value24hr = _b === void 0 ? '' : _b, setValue24hr = _a.setValue, _c = _a.forcePolyfill, forcePolyfill = _c === void 0 ? false : _c, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onKeyDown = _a.onKeyDown, _d = _a.className, className = _d === void 0 ? '' : _d, style = _a.style, _e = _a.polyfillSource, polyfillSource = _e === void 0 ? 'https://cdn.jsdelivr.net/npm/@time-input-polyfill/utils@1' : _e, restProps = __rest(_a, ["value", "setValue", "forcePolyfill", "onChange", "onFocus", "onBlur", "onMouseDown", "onMouseUp", "onKeyDown", "className", "style", "polyfillSource"]);
    var isPolyfilled = forcePolyfill || !supportsTime_1.default;
    var value24hrCache = (0, react_1.useRef)(value24hr);
    var update24hr = function (newValue24Hr) {
        value24hrCache.current = newValue24Hr;
        setValue24hr(newValue24Hr);
    };
    var $input = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(null), polyfill = _f[0], setPolyfill = _f[1];
    var _g = (0, react_1.useState)(false), hasInitialised = _g[0], setHasInitialised = _g[1];
    var _h = (0, react_1.useState)(false), focusedViaClick = _h[0], setFocusedViaClick = _h[1];
    var _j = (0, react_1.useState)(blankValues_1.blankValues.string12hr), value12hr = _j[0], setValue12hr = _j[1];
    var _k = (0, react_1.useState)(blankValues_1.blankValues.timeObject), timeObject = _k[0], setTimeObject = _k[1];
    var _l = (0, react_1.useState)(null), cursorSegment = _l[0], setCursorSegment = _l[1];
    var cursorSegmentRef = (0, react_1.useRef)(cursorSegment);
    var _m = (0, react_1.useState)(false), allowSegmentSelection = _m[0], setAllowSegmentSelection = _m[1];
    var _o = (0, react_1.useState)(null), manualEntryLog = _o[0], setManualEntryLog = _o[1];
    (0, react_1.useEffect)(function () {
        var isBeingExternallySet = value24hr !== value24hrCache.current;
        if (isBeingExternallySet && polyfill) {
            setTimeObject(polyfill.convertString24hr(value24hr).toTimeObject());
        }
    }, [value24hr, polyfill]);
    /*
        <Forced override value code>

        If a developer for some reason wants to use normal submit functionality
        This will quickly switch IE form inputs to 24 hour time before submitting
        then switch back afterwards so the user doesn't notice
    */
    var _p = (0, react_1.useState)(undefined), forcedValue = _p[0], setForcedValue = _p[1];
    // Watch for form submission events and override the displayed time value on submit
    (0, react_1.useEffect)(function () {
        var _a;
        var overrideTime = function () {
            setForcedValue(value24hr);
            setTimeout(function () { return setForcedValue(undefined); }, 1);
        };
        var $inputElement = $input.current;
        (_a = $inputElement === null || $inputElement === void 0 ? void 0 : $inputElement.form) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', overrideTime);
        return function () {
            var _a;
            (_a = $inputElement === null || $inputElement === void 0 ? void 0 : $inputElement.form) === null || _a === void 0 ? void 0 : _a.removeEventListener('submit', overrideTime);
        };
    }, [value24hr]);
    /* </Forced override value code>	*/
    var getBlankValuesStatus = function (timeObject) {
        if (!polyfill || !isPolyfilled)
            return {};
        var isBlankValue = function (key) { return timeObject[key] === null; };
        var timeObjectKeys = polyfill.timeObjectKeys;
        return {
            hasBlankValues: timeObjectKeys.some(isBlankValue),
            isAllBlankValues: timeObjectKeys.every(isBlankValue),
        };
    };
    // Do all modifications through the timeObject. React will update the other values accordingly.
    (0, react_1.useEffect)(function () {
        if (polyfill && isPolyfilled) {
            var convertTimeObject = polyfill.convertTimeObject, getCursorSegment = polyfill.getCursorSegment, selectSegment_1 = polyfill.selectSegment;
            var segment_1 = cursorSegment || getCursorSegment($input.current);
            var timeObjAs24hr = convertTimeObject(timeObject).to24hr();
            var timeObjAs12hr = convertTimeObject(timeObject).to12hr();
            if (value12hr !== timeObjAs12hr) {
                setValue12hr(timeObjAs12hr);
                update24hr(timeObjAs24hr);
            }
            if (allowSegmentSelection) {
                setTimeout(function () {
                    selectSegment_1($input.current, segment_1);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowSegmentSelection, cursorSegment, polyfill, isPolyfilled, timeObject]);
    (0, react_1.useEffect)(function () {
        if (polyfill && isPolyfilled) {
            var a11yUpdate_1 = polyfill.a11yUpdate, getA11yValue_1 = polyfill.getA11yValue;
            setTimeout(function () {
                if (getA11yValue_1()) {
                    a11yUpdate_1($input.current, ['update']);
                }
            });
        }
    }, [timeObject, polyfill, isPolyfilled]);
    (0, react_1.useEffect)(function () {
        if (polyfill && isPolyfilled) {
            var convertString24hr = polyfill.convertString24hr, matchesTimeObject = polyfill.matchesTimeObject;
            var newTimeObject = convertString24hr(value24hr).toTimeObject();
            var hasBlankValues = getBlankValuesStatus(newTimeObject).hasBlankValues;
            if (!matchesTimeObject(newTimeObject, timeObject) &&
                hasInitialised &&
                !hasBlankValues) {
                setTimeObject(newTimeObject);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value24hr, polyfill, isPolyfilled]);
    (0, react_1.useEffect)(function () {
        if (isPolyfilled) {
            // I tried making an "essentials only" utils js file. It somehow ended up turning into a MUCH larger file size than the original utils file.
            // Original utils file size: 19,848 bytes; essentials only file size: 24,481 bytes
            // So I just download the full utils instead of trying to reduce it.
            // Don't worry, it only downloads the polyfill once no matter how many inputs you have on the page
            (0, load_js_1.default)(polyfillSource, function () {
                if (window.timeInputPolyfillUtils) {
                    var _a = window.timeInputPolyfillUtils, convertString12hr_1 = _a.convertString12hr, convertString24hr = _a.convertString24hr, a11yCreate = _a.a11yCreate, getA11yElement = _a.getA11yElement, ManualEntryLog_1 = _a.ManualEntryLog, getNextSegment_1 = _a.getNextSegment;
                    setPolyfill(window.timeInputPolyfillUtils);
                    var timeObject_1 = convertString24hr(value24hr).toTimeObject();
                    setTimeObject(timeObject_1);
                    if (!getA11yElement()) {
                        a11yCreate();
                    }
                    setManualEntryLog(new ManualEntryLog_1({
                        timeObject: timeObject_1,
                        onUpdate: function (_a) {
                            var fullValue12hr = _a.fullValue12hr;
                            var timeObj = convertString12hr_1(fullValue12hr).toTimeObject();
                            setTimeObject(timeObj);
                        },
                        onLimitHit: function () {
                            setCursorSegment(getNextSegment_1(cursorSegmentRef.current));
                        },
                    }));
                    setHasInitialised(true);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPolyfilled]);
    var resetSegmentEntryLog = function () {
        if (manualEntryLog && cursorSegment) {
            manualEntryLog[cursorSegment].reset();
        }
    };
    (0, react_1.useEffect)(function () {
        cursorSegmentRef.current = cursorSegment;
        var hasFocus = document.activeElement === $input.current;
        if (polyfill && isPolyfilled && hasFocus) {
            var a11yUpdate_2 = polyfill.a11yUpdate, getA11yValue_2 = polyfill.getA11yValue;
            setTimeout(function () {
                if (getA11yValue_2()) {
                    a11yUpdate_2($input.current, ['select']);
                }
                else {
                    a11yUpdate_2($input.current, ['initial', 'select']);
                }
            });
        }
    }, [cursorSegment, polyfill, isPolyfilled]);
    //Reset entry log cursor segmet
    (0, react_1.useEffect)(function () {
        resetSegmentEntryLog();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursorSegment, manualEntryLog]);
    var handleChange = function (e) {
        if (onChange)
            onChange(e);
        // This is needed to guard against virtual keyboards sending 12hr strings in the change event.
        // Mobile devices are not supported by this polyfill, all mobile devices support time inputs natively.
        if (!isPolyfilled || (polyfill === null || polyfill === void 0 ? void 0 : polyfill.isString24hr(e.target.value))) {
            update24hr(e.target.value);
            return;
        }
    };
    var handleFocus = function (e) {
        if (onFocus)
            onFocus(e);
        if (polyfill && isPolyfilled) {
            setAllowSegmentSelection(true);
            var isShiftHeldDown = polyfill.isShiftHeldDown, getCursorSegment_1 = polyfill.getCursorSegment, a11yUpdate = polyfill.a11yUpdate;
            if (focusedViaClick) {
                // Need to wait for browser to settle before detecting the cursor segment
                setTimeout(function () {
                    setCursorSegment(getCursorSegment_1($input.current));
                });
            }
            else {
                setCursorSegment(isShiftHeldDown ? 'mode' : 'hrs12');
            }
            resetSegmentEntryLog();
            a11yUpdate($input.current, ['initial', 'select']);
        }
    };
    var handleBlur = function (e) {
        if (onBlur)
            onBlur(e);
        setAllowSegmentSelection(false);
        setFocusedViaClick(false);
        polyfill === null || polyfill === void 0 ? void 0 : polyfill.a11yClear();
    };
    var handleMouseDown = function (e) {
        if (onMouseDown)
            onMouseDown(e);
        setFocusedViaClick(true);
    };
    var handleMouseUp = function (e) {
        if (onMouseUp)
            onMouseUp(e);
        if (polyfill && isPolyfilled) {
            polyfill.selectCursorSegment($input.current);
        }
    };
    var handleKeyDown = function (e) {
        if (onKeyDown)
            onKeyDown(e);
        if (polyfill && isPolyfilled) {
            var key = e.key;
            var userChangeEvent = function () { return onChange && onChange(e); };
            var modifyTimeObject = polyfill.modifyTimeObject, getCursorSegment = polyfill.getCursorSegment, getNextSegment = polyfill.getNextSegment, getPrevSegment = polyfill.getPrevSegment, isShiftHeldDown = polyfill.isShiftHeldDown, regex = polyfill.regex;
            var segment = cursorSegment || getCursorSegment($input.current);
            if (key === 'ArrowUp') {
                if (!cursorSegment)
                    setCursorSegment(segment);
                e.preventDefault();
                resetSegmentEntryLog();
                setTimeObject(modifyTimeObject(timeObject).increment[segment].isolated());
                userChangeEvent();
            }
            else if (key === 'ArrowDown') {
                if (!cursorSegment)
                    setCursorSegment(segment);
                e.preventDefault();
                resetSegmentEntryLog();
                setTimeObject(modifyTimeObject(timeObject).decrement[segment].isolated());
                userChangeEvent();
            }
            else if (key === 'ArrowLeft') {
                e.preventDefault();
                setCursorSegment(getPrevSegment(cursorSegment));
            }
            else if (key === 'ArrowRight') {
                e.preventDefault();
                setCursorSegment(getNextSegment(cursorSegment));
            }
            else if (key === 'Tab') {
                var isNormal = (isShiftHeldDown && cursorSegment === 'hrs12') ||
                    (!isShiftHeldDown && cursorSegment === 'mode');
                if (!isNormal) {
                    e.preventDefault();
                    var theNextSegment = isShiftHeldDown
                        ? getPrevSegment(cursorSegment)
                        : getNextSegment(cursorSegment);
                    setCursorSegment(theNextSegment);
                }
            }
            else if (['Backspace', 'Delete'].includes(key)) {
                e.preventDefault();
                if (cursorSegment) {
                    setTimeObject(modifyTimeObject(timeObject).clear[cursorSegment]());
                }
                userChangeEvent();
            }
            else if (regex.alphaNumericKeyName.test(key) && manualEntryLog) {
                e.preventDefault();
                manualEntryLog[segment].add(key);
                userChangeEvent();
            }
        }
    };
    var polyfillClass = isPolyfilled ? polyfillClassName : '';
    var styles = __assign({ fontFamily: 'monospace' }, style);
    var polyfilledValue = forcedValue === undefined ? value12hr : forcedValue;
    return (react_1.default.createElement("input", __assign({}, restProps, { onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onKeyDown: handleKeyDown, ref: $input, type: isPolyfilled ? 'text' : 'time', value: isPolyfilled ? polyfilledValue : value24hr, style: styles, className: [className, polyfillClass].join(' ').trim() || undefined })));
};
var _TimeInputPolyfill = react_1.default.memo(TimeInputPolyfill);
exports.TimeInputPolyfill = _TimeInputPolyfill;
exports.default = _TimeInputPolyfill;
